module.exports = __webpack_public_path__ + "static/media/dashboard.9260a188.png";